<div class="report-card">
  <div class="header">
    Past Due
    <span class="sub-header">
      As of Today
      @if (employee && !companyWide) {
        <span>, {{employee.fullName}}</span>
      }
      @if (companyWide) {
        <span>, All</span>
      }
    </span>
  </div>

  <app-loading-swirly [isLoading]="totalsLoading"></app-loading-swirly>

  @if (!totalsLoading) {
    <div>
      <div class="big-header" style="text-align: left; margin-bottom: 8px;">
        {{ranges.underThirtyTotal | currency:'USD':'symbol':'0.0-2' }}
        <div class="small">
          < 30 Days Old
        </div>
      </div>
      <div>
        <div class="pretend-table-row">
          <span>
            Work Order
          </span>
          <span>
            Total
          </span>
        </div>
        <div class="horizontal-line"></div>
      </div>
      @if (ranges.underThirty.length == 0) {
        <div class="fine-print" style="text-align: center;">
          No < 30 days past due!
        </div>
      }
      @for (record of ranges.underThirty; track record; let i = $index) {
        <div>
          @if (i < 3 || showAllUnderThirty) {
            <span>
              <div class="pretend-table-row">
                <span>
                  <a target="_blank" class="regular-link" (click)="goToWorkOrder(record)">{{record.number}}</a>
                  @if (record.range == '') {
                    <i class="pi pi-exclamation-triangle" pTooltip="Has a completed task with no completed date" tooltipPosition="bottom" style="vertical-align: sub;"></i>
                  }
                </span>
                <span>
                  {{record.total | currency:'USD':'symbol':'0.0-2' }}
                </span>
              </div>
              <div class="horizontal-line"></div>
            </span>
          }
        </div>
      }
      @if (ranges.underThirty.length > 3 && !showAllUnderThirty) {
        <div class="regular-link" (click)="showAllUnderThirty = true">+ LOAD MORE +</div>
      }
      @if (ranges.underThirty.length > 3 && showAllUnderThirty) {
        <div class="regular-link" (click)="showAllUnderThirty = false">+ SHOW LESS +</div>
      }
      <div class="big-header" style="text-align: left; margin-bottom: 8px;">
        {{ranges.thirtyToSixtyTotal | currency:'USD':'symbol':'0.0-2' }}
        <div class="small">
          31-60 Days Old
        </div>
      </div>
      <div>
        <div class="pretend-table-row">
          <span>
            Work Order
          </span>
          <span>
            Total
          </span>
        </div>
        <div class="horizontal-line"></div>
      </div>
      @if (ranges.thirtyToSixty.length == 0) {
        <div class="fine-print" style="text-align: center;">
          No 31 - 60 days past due!
        </div>
      }
      @for (record of ranges.thirtyToSixty; track record; let i = $index) {
        <div>
          @if (i < 3 || showAllThirtyToSixty) {
            <span>
              <div class="pretend-table-row">
                <span>
                  <a target="_blank" class="regular-link" (click)="goToWorkOrder(record)">{{record.number}}</a>
                </span>
                <span>
                  {{record.total | currency:'USD':'symbol':'0.0-2' }}
                </span>
              </div>
              <div class="horizontal-line"></div>
            </span>
          }
        </div>
      }
      @if (ranges.thirtyToSixty.length > 3 && !showAllThirtyToSixty) {
        <div class="regular-link" (click)="showAllThirtyToSixty = true">+ LOAD MORE +</div>
      }
      @if (ranges.thirtyToSixty.length > 3 && showAllThirtyToSixty) {
        <div class="regular-link" (click)="showAllThirtyToSixty = false">+ SHOW LESS +</div>
      }
      <div class="big-header" style="text-align: left; margin-bottom: 8px;">
        {{ranges.overSixtyTotal | currency:'USD':'symbol':'0.0-2' }}
        <div class="small">
          60+ Days Old
        </div>
      </div>
      <div>
        <div class="pretend-table-row">
          <span>
            Work Order
          </span>
          <span>
            Total
          </span>
        </div>
        <div class="horizontal-line"></div>
      </div>
      @for (record of ranges.overSixty; track record; let i = $index) {
        <div>
          @if (i < 3 || showAllOverSixty) {
            <span>
              <div class="pretend-table-row">
                <span>
                  <a target="_blank" class="regular-link" (click)="goToWorkOrder(record)">{{record.number}}</a>
                </span>
                <span>
                  {{record.total | currency:'USD':'symbol':'0.0-2' }}
                </span>
              </div>
              <div class="horizontal-line"></div>
            </span>
          }
        </div>
      }
      @if (ranges.overSixty.length > 3 && !showAllOverSixty) {
        <div class="regular-link" (click)="showAllOverSixty = true">+ LOAD MORE +</div>
      }
      @if (ranges.overSixty.length > 3 && showAllOverSixty) {
        <div class="regular-link" (click)="showAllOverSixty = false">+ SHOW LESS +</div>
      }
      <div style="margin-top: 12px;" class="thicker-horizontal-line"></div>
      <div class="big-header" style="text-align: left;">
        <span [ngStyle]="{ 'color': mainColor }">
          {{ (ranges.underThirtyTotal + ranges.thirtyToSixtyTotal + ranges.overSixtyTotal) | currency:'USD':'symbol':'0.0-2' }}
        </span>
        <div class="small">
          All Past Due
        </div>
      </div>
    </div>
  }
</div>
